import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import { EnvService } from '../services/env.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { debounceTime } from 'rxjs';
import { SettingsPersistenceService } from '../services/settings-persistence.service';
import { AuthService } from '../services/auth.service';
import { OsVersionsFilter } from './os-versions.filter';


@Component({
  selector: 'app-osVersions',
  templateUrl: './os-versions.component.html',
})
export class OsVersionsComponent {
  dataSource = new MatTableDataSource<any>();
  osFamilyNames = new Map<string, string>();

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  pageSettings!: SettingsPersistenceService;
  filter = new OsVersionsFilter(this.auth);

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient) {
  }

  ngOnInit(): void {
    // Setup the settings persistence service for this page
    this.pageSettings = new SettingsPersistenceService(sessionStorage, 'micro.osVersions');
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .init();

    // Subscribe to filter changes with a debounce time to avoid excessive reloads
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    // Initial data load
    this.reload();
  }

  ngOnDestroy(): void {
  }

  reload(): void {
    const params: HttpParams = this.filter.getParams()
      .set('page', String(this.paginator.pageIndex || 0))
      .set('size', String(this.paginator.pageSize || 20));

    this.http.get(`${this.env.e.url}/domain/cmdbOsVersions`, {params}).subscribe(data => {
      const page = data as any;
      this.dataSource.data = page.content;
      this.loadOSFamilyNames(page.content || []);
      this.paginator.pageIndex = page.number;
      this.paginator.pageSize = page.size;
      this.paginator.length = page.totalElements;
    });
  }

  private loadOSFamilyNames(osVersions: any[]): void {
    const osFamilyIds = [...new Set(osVersions
      .map(osVersion => osVersion.osFamilyId)
      .filter(tagId => tagId && !this.osFamilyNames.has(tagId)))];

    osFamilyIds.forEach(id => {
      this.http.get(`${this.env.e.url}/domain/cmdbOsFamily/${id}`).subscribe({
        next: (osFamily: any) => {
          this.osFamilyNames.set(id, osFamily ? osFamily.name : '');
          this.dataSource.data = [...this.dataSource.data];
        },
        error: () => {
          this.osFamilyNames.set(id, '');
          this.dataSource.data = [...this.dataSource.data];
        }
      });
    });
  }
}
